module.exports = __webpack_public_path__ + "assets/home.953f07eeae9f798e5538b30806a50769.svg";


//////////////////
// WEBPACK FOOTER
// ./img/home.svg
// module id = 584
// module chunks = 0